/* eslint-disable */
import { rootApi } from '../rootApi';

export const dealerOtherLaborPriceApi = rootApi.injectEndpoints({
    endpoints: (builder) => ({
        getAllDealerOtherLaborPrice: builder.query({
            query: ({ pageNumber = 1, pageSize = 10, languageId, isActive = 1 }) => ({
                url: 'v1/dealerotherlaborprice/dealer-other-labor-price-getall',
                method: 'GET',
                params: {
                    pageNumber,
                    pageSize,
                    IsActive: isActive,
                    ...(languageId ? { LanguageId: languageId } : {})
                }
            }),
            transformResponse: (response) => {
                if (response?.data?.items) {
                    // Normalize field names - ensure both PascalCase and camelCase are available
                    const normalizedItems = response.data.items.map(item => ({
                        ...item,
                        // Keep original PascalCase fields
                        ContractStartDate: item.ContractStartDate || item.contractStartDate,
                        ContractEndDate: item.ContractEndDate || item.contractEndDate,
                        // Also add camelCase versions for compatibility
                        contractStartDate: item.ContractStartDate || item.contractStartDate,
                        contractEndDate: item.ContractEndDate || item.contractEndDate,
                        // Keep other fields as they are
                        id: item.Id || item.id,
                        price: item.Price || item.price,
                        currency: item.Currency || item.currency,
                        IsActive: item.IsActive !== undefined ? item.IsActive : item.isActive,
                        isActive: item.IsActive !== undefined ? item.IsActive : item.isActive
                    }));
                    return {
                        items: normalizedItems,
                        totalCount: response.data.totalCount || 0
                    };
                }
                return { items: [], totalCount: 0 };
            },
            providesTags: ['DealerOtherLaborPrice']
        }),

        createDealerOtherLaborPrice: builder.mutation({
            query: (data) => ({
                url: 'v1/dealerotherlaborprice/dealer-other-labor-price',
                method: 'POST',
                body: data
            }),
            invalidatesTags: ['DealerOtherLaborPrice']
        }),

        updateDealerOtherLaborPrice: builder.mutation({
            query: (data) => ({
                url: 'v1/dealerotherlaborprice/dealer-other-labor-price-update',
                method: 'PATCH',
                body: data
            }),
            invalidatesTags: ['DealerOtherLaborPrice']
        }),

        deleteDealerOtherLaborPrice: builder.mutation({
            query: (data) => ({
                url: 'v1/dealerotherlaborprice/dealer-other-labor-price-delete',
                method: 'DELETE',
                body: data
            }),
            invalidatesTags: ['DealerOtherLaborPrice']
        })
    })
});

export const {
    useGetAllDealerOtherLaborPriceQuery,
    useCreateDealerOtherLaborPriceMutation,
    useUpdateDealerOtherLaborPriceMutation,
    useDeleteDealerOtherLaborPriceMutation
} = dealerOtherLaborPriceApi;

